var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../service/api.service';
import { ContentBaseService } from '../base/contentbase.service';
import { ColumnService } from '../../items/columns/column/column.service';
var RegistryCondService = /** @class */ (function (_super) {
    __extends(RegistryCondService, _super);
    function RegistryCondService(logger, api, colservice) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.colservice = colservice;
        return _this;
    }
    RegistryCondService.prototype.getDispFlg = function () {
        this.baseUrl = '/v1/gen/code-m-service?query={"predicateList":[{"name":"code_category_m.name","value":"boolFlg","operator":"eq"}],"orderByList":[{"name":"key","direction":"asc"}]}';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            var options = [];
            for (var _i = 0, _a = data.items; _i < _a.length; _i++) {
                var item = _a[_i];
                options.push({ code: item.key, display: item.label });
            }
            return options;
        }));
    };
    RegistryCondService.prototype.checkItem = function (rec) {
        var items = rec['items'] || [];
        var check = true;
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (!this.colservice.checkVal(item.is_available) || !this.colservice.checkVal(item.is_limited) || ((item.is_limited.toString() === 'true') && !this.colservice.checkVal(item.times_limit))) {
                check = false;
            }
        }
        return check;
    };
    RegistryCondService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    RegistryCondService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: ColumnService }
    ]; };
    return RegistryCondService;
}(ContentBaseService));
export { RegistryCondService };
var RegistryCond = /** @class */ (function () {
    function RegistryCond() {
        this.$type = "post" /* Post */;
        this.is_available = true;
        this.is_limited = false;
    }
    return RegistryCond;
}());
export { RegistryCond };
var Behavior = /** @class */ (function () {
    function Behavior() {
    }
    return Behavior;
}());
export { Behavior };
//# sourceMappingURL=registry-cond.service.js.map